<script setup lang="ts">
import { computed } from "vue";
import TextFieldGroup from "@/components/molecules/form/TextFieldGroup.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import ReferAttention from "@/components/organisms/mypage/referPromotion/ReferAttention.vue";

const props = defineProps({
  alreadyReferred: {
    type: Boolean,
    required: true
  },
  alreadyWorked: {
    type: Boolean,
    required: true
  },
  canApplyPromotion: {
    type: Boolean,
    required: true
  },
  promotionCode: {
    type: String,
    required: true
  }
});

const emits = defineEmits(["click", "update:promotionCode"]);

const promotionCodeValue = computed({
  get: () => props.promotionCode,
  set: (value: string) => {
    emits("update:promotionCode", value);
  }
});

const submitButtonText = computed(() => {
  return props.alreadyReferred ? "登録済" : "登録";
});

const onClick = () => {
  emits("click");
};
</script>

<template>
  <div :class="{ 'gray-out': !canApplyPromotion }">
    <div
      v-if="alreadyWorked"
      class="d-flex flex-column align-items-center mb-4"
    >
      <div class="mb-3">
        初勤務完了済のため、ご利用いただけません
      </div>
      <img
        class="refer-promotion-img"
        src="@/assets/svg/caikuma_refer_promotion.svg"
      />
    </div>
    <h2 class="text-size-14 text-mild section-title">招待コード入力</h2>
    <div class="mb-3">
      <CustomValidationObserver ref="vObserver" v-slot="{ handleSubmit }">
        <ValidationProvider
          v-slot="validationState"
          name="招待コード"
          :rules="{ required: true, length: 8 }"
          vid="code"
        >
          <TextFieldGroup
            v-model="promotionCodeValue"
            :disabled="!canApplyPromotion"
            placeholder="招待コードを入力してください"
            :validationState="validationState"
            class="mt-3"
          />
        </ValidationProvider>

        <AppButton
          block
          :disabled="!canApplyPromotion || alreadyReferred"
          class="text-size-14 mt-2"
          @click="handleSubmit(onClick)"
        >
          {{ submitButtonText }}
        </AppButton>
      </CustomValidationObserver>
    </div>
  </div>
</template>

<style scoped lang="scss">
.gray-out {
  color: $gray-05;

  .section-title,
  span {
    color: $gray-05 !important;
  }

  .order-list li::before {
    color: $white !important;
    background-color: $gray-03 !important;
  }
}

.section-title {
  color: $mild;
}

.order-list li {
  margin-bottom: 16px;
  counter-increment: cnt;
}

.order-list li::before {
  padding: 0 8px;
  margin-right: 8px;
  font-weight: 200;
  color: $white;
  content: counter(cnt);
  background-color: #fbce5a;
  border-radius: 50%;
}

.refer-promotion-img {
  width: auto;
  height: 96px;
}
</style>
